// export const SERVER_URL = 'http://localhost:5000/v1/'
export const SERVER_URL = 'http://api.khetipoint.co.in/v1'

export const DELAR_APP_SESSION = 'delar_app_session'
export const DELAR_APP_TOKEN = 'delar_app_token'

export const DELAR_APP_LANG_CODE = 'delar_app_lang_code'